import ShowBulkUploadView from './ShowBulkUploadView';

export default ShowBulkUploadView;
